import { useMemo } from 'react';
import { useAuthStore } from '../../stores/auth';
import { TOUR_STEPS } from '../../onboarding/tourSteps';
import { GuidedTourShell } from './GuidedTourShell';

const STORAGE_KEY = 'servicehub.tour.completed';
const OPEN_EVENT = 'servicehub:start-tour';

/** Von überall startbar — z. B. aus der Hilfe-Seite. */
export function startGuidedTour(): void {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

export function hasCompletedGuidedTour(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

/** Rundgang durchs Techniker-Portal. Admin-Stationen nur für Admins. */
export function GuidedTour() {
  const { user } = useAuthStore();
  const isAdmin = user?.role === 'ADMIN';

  const steps = useMemo(
    () => TOUR_STEPS.filter((s) => !s.adminOnly || isAdmin),
    [isAdmin],
  );

  return <GuidedTourShell steps={steps} openEvent={OPEN_EVENT} storageKey={STORAGE_KEY} />;
}
